var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionFavoriteOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m12 14.853 3.198 2.17-.907-3.89 3.127-2.274-4.07-.346L12 6.643l-1.348 3.87-4.07.345 3.127 2.274-.907 3.89L12 14.854Zm-5.39 6.072a.434.434 0 0 1-.666-.457L7.46 13.97l-5.24-3.81a.532.532 0 0 1 .267-.961L9.19 8.63l2.146-6.158a.704.704 0 0 1 1.329 0L14.81 8.63l6.703.569a.532.532 0 0 1 .268.96L16.54 13.97l1.516 6.498a.434.434 0 0 1-.666.457L12 17.27l-5.39 3.655Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionFavoriteOutlined);
export default __webpack_public_path__ + "static/media/ic_action_favorite_outlined.fe7e842b7a688349d8acc39ecd230279.svg";
export { ForwardRef as ReactComponent };